var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 11,
    viewBox: "0 0 19 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.80575 10.143L5.19588 9.71154L5.8521 7.26254C4.86118 6.89754 3.95069 6.36621 3.15448 5.70254L1.36004 7.49696L0.181533 6.31846L1.97598 4.52404C0.983358 3.33329 0.286967 1.88692 0 0.298192L1.64007 0C2.27259 3.50187 5.33628 6.15812 9.02035 6.15812C12.7044 6.15812 15.7682 3.50187 16.4007 0L18.0408 0.298192C17.7538 1.88692 17.0574 3.33329 16.0648 4.52404L17.8592 6.31846L16.6807 7.49696L14.8863 5.70254C14.09 6.36621 13.1795 6.89754 12.1886 7.26254L12.8449 9.71154L11.235 10.143L10.5785 7.69287C10.0721 7.77962 9.55152 7.82479 9.02035 7.82479C8.48927 7.82479 7.9686 7.77962 7.46227 7.69287L6.80575 10.143Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.93be38f5012fa4d455e3326333a636c3.svg";
export { ForwardRef as ReactComponent };